import React from "react";
import { useSelector } from "react-redux";
import { selectPumpDetails } from "../../../redux/selectors";
import { getPumpDisplayLabel, normalizePumpId } from "../Mechanical/Pumps/pumpIdHelpers";

const PrintPumpTable = () => {
  const pumpDetails = useSelector(selectPumpDetails);

  const generatePumpLabels = (pumps) => {
    let pumpCounter = 1;
    let jockeyCounter = 1;

    const sortedPumps = [...pumps].sort((a, b) => {
      const aVFD = a.VFD ? parseInt(a.VFD.replace(/\D/g, "")) : Infinity;
      const bVFD = b.VFD ? parseInt(b.VFD.replace(/\D/g, "")) : Infinity;
      return aVFD - bVFD;
    });

    const jockeyExists = sortedPumps.some(pump => normalizePumpId(pump.PumpID) === "jockey");
    if (jockeyExists) {
      pumpCounter = 2;
    }

    const updatedPumps = sortedPumps.map((pump) => {
      const newPump = { ...pump };
      const pumpType = normalizePumpId(newPump.PumpID);
      if (pumpType === "jockey") {
        newPump.DisplayPumpID = `Jockey Pump ${jockeyCounter}`;
        jockeyCounter += 1;
      } else if (pumpType === "main") {
        if (newPump.Quantity > 1) {
          const start = pumpCounter;
          const end = pumpCounter + parseInt(newPump.Quantity) - 1;
          newPump.DisplayPumpID = `Main Pumps ${start}-${end}`;
          pumpCounter = end + 1;
        } else {
          newPump.DisplayPumpID = `Main Pump ${pumpCounter}`;
          pumpCounter += 1;
        }
      } else {
        newPump.DisplayPumpID = `${getPumpDisplayLabel(newPump.PumpID)} Pump`;
      }
      return newPump;
    });
    return updatedPumps;
  };

  const renderDetails = (details) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return null;
    }

    const groupedDetails = details.reduce((acc, detail) => {
      if (!acc[detail.Zone]) {
        acc[detail.Zone] = [];
      }
      acc[detail.Zone].push(detail);
      return acc;
    }, {});

    return (
      <div>
        {Object.keys(groupedDetails).map((zone, index) => {
          const zoneDetails = generatePumpLabels(groupedDetails[zone]);

          return (
            <div className="section" key={index}>
              <h3 className="print-zone-label">Zone: {zone}</h3>
              <table className="table table-bordered full-width">
                <thead>
                  <tr>
                    <th>Pump ID</th>
                    <th>HP</th>
                    <th>RPM</th>
                    <th>GPM</th>
                    <th>HTR</th>
                    <th>XL</th>
                    <th>VFD</th>
                    <th>SS</th>
                    <th>EBV</th>
                    <th>Motor Temp Switch</th>
                    <th>Pump Temp Sensor</th>
                    <th>DV/DT Filters</th>
                    <th>Line Reactor</th>
                  </tr>
                </thead>
                <tbody>
                  {zoneDetails.map((detail, idx) => (
                    <tr key={idx}>
                      <td>{detail.DisplayPumpID}</td>
                      <td>{detail.MotorHP}</td>
                      <td>{detail.PumpRPM}</td>
                      <td>{detail.PumpFlow}</td>
                      <td>{detail.MotorWindingHeaters}</td>
                      <td>{detail.XL}</td>
                      <td>{detail.VFD}</td>
                      <td>{detail.SS}</td>
                      <td>{detail.EBV}</td>
                      <td>{detail.MotorTempSwitch}</td>
                      <td>{detail.PumpTempSensor}</td>
                      <td>{detail.DVDT}</td>
                      <td>{detail.LineReactor}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div>
      <h2 className="print-section-header">Pump Table Summary</h2>
      {renderDetails(pumpDetails)}
    </div>
  );
};

export default PrintPumpTable;
